// src/index.ts
import {
  object,
  string,
  literal,
  special,
  variant,
  number,
  toLowerCase,
  union,
  optional,
  forward,
  custom
} from "valibot";
import { parse } from "valibot";
var string0x = (...args) => special((val) => typeof val === "string" ? val.startsWith("0x") : false, "do not start with 0x", [
  toLowerCase(),
  ...args
]);
var SchemaPublicKey = string0x();
var SchemaAddress = string0x();
var SchemaActionSendMessage = object(
  {
    type: literal("sendMessage"),
    domain: string(),
    namespace: string(),
    to: string0x(),
    toPublicKey: optional(string0x()),
    message: string(),
    messageType: union([literal("clear"), literal("encrypted")]),
    signature: string0x()
  },
  [
    forward(
      custom(({ toPublicKey, messageType }) => {
        if (messageType === "clear") {
          return toPublicKey ? false : true;
        } else {
          return toPublicKey ? true : false;
        }
      }, "toPublicKey is required when message is encrypted and forbidden when message is clear"),
      ["toPublicKey"]
    )
  ]
);
var SchemaActionAcceptConversation = object({
  type: literal("acceptConversation"),
  domain: string(),
  namespace: string(),
  conversationID: string()
});
var SchemaActionGetConversations = object({
  type: literal("getConversations"),
  domain: string(),
  namespace: string()
});
var SchemaActionGetUnacceptedConversations = object({
  type: literal("getUnacceptedConversations"),
  domain: string(),
  namespace: string()
});
var SchemaActionGetAcceptedConversations = object({
  type: literal("getAcceptedConversations"),
  domain: string(),
  namespace: string()
});
var SchemaActionMarkAsRead = object({
  type: literal("markAsRead"),
  domain: string(),
  namespace: string(),
  conversationID: string(),
  lastMessageTimestampMS: number()
});
var SchemaActionGetMessages = object({
  domain: string(),
  namespace: string(),
  type: literal("getMessages"),
  conversationID: string()
});
var SchemaActionGetMissivUser = object({
  type: literal("getUser"),
  address: string0x()
});
var SchemaActionGetDomainUser = object({
  type: literal("getDomainUser"),
  domain: string(),
  address: string0x()
});
var SchemaActionRegisterDomainUser = object({
  type: literal("register"),
  domain: string(),
  signature: string0x(),
  address: string0x(),
  name: optional(string()),
  domainUsername: optional(string())
});
var SchemaAction = variant("type", [
  SchemaActionRegisterDomainUser,
  SchemaActionSendMessage,
  SchemaActionGetConversations,
  SchemaActionGetUnacceptedConversations,
  SchemaActionGetAcceptedConversations,
  SchemaActionMarkAsRead,
  SchemaActionGetMessages,
  SchemaActionAcceptConversation,
  SchemaActionGetMissivUser,
  SchemaActionGetDomainUser,
  object({
    type: literal("db:select"),
    table: string()
  }),
  object({
    type: literal("db:reset")
  })
]);
function getConversationID(accountA, accountB) {
  accountA = accountA.toLowerCase();
  accountB = accountB.toLowerCase();
  if (accountA > accountB) {
    return `${accountA}${accountB}`;
  } else {
    return `${accountB}${accountA}`;
  }
}
function publicKeyAuthorizationMessage({
  address,
  publicKey
}) {
  return `I authorize the following Public Key to represent me:
 ${publicKey}

  Others can use this key to write me messages`;
}
export {
  SchemaAction,
  SchemaActionAcceptConversation,
  SchemaActionGetAcceptedConversations,
  SchemaActionGetConversations,
  SchemaActionGetDomainUser,
  SchemaActionGetMessages,
  SchemaActionGetMissivUser,
  SchemaActionGetUnacceptedConversations,
  SchemaActionMarkAsRead,
  SchemaActionRegisterDomainUser,
  SchemaActionSendMessage,
  SchemaAddress,
  SchemaPublicKey,
  getConversationID,
  parse,
  publicKeyAuthorizationMessage
};
//# sourceMappingURL=index.js.map